/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.envoiAcces.ts
 *
 * Messages de l'ENVOI D'ACCÈS PAR COURRIEL depuis l'écran « Codes d'accès »
 * (/admin/exhibitor-codes, 2026-10-06, demande de Mika) et de la carte des
 * adresses en copie. Fusionné dans fr.ts.
 *
 * Plateforme multi-événements : aucun nom d'événement ni « salon »,
 * « atelier », « exposant » écrits en dur ; le vocabulaire passe par les
 * jetons {lex...}. Apostrophe typographique partout (en ICU, l'apostrophe
 * droite échappe l'accolade qui la suit). Aucun tiret cadratin.
 *
 * Mikael - chef de projet - 2026-10-06
 */
export const messagesEnvoiAccesFr: Record<string, string> = {
  // ── Ouverture ──────────────────────────────────────────────────────────
  'envoiAcces.btn.ouvrir': 'Envoyer un accès par courriel',
  'envoiAcces.btn.envoyerCode': 'Envoyer par courriel',
  'envoiAcces.modal.titre': 'Envoyer un accès par courriel',
  'envoiAcces.intro':
    'Le courriel part du site, avec le modèle du profil choisi (Modèles d’e-mail). Le code reçoit le libellé « Prénom Nom (organisme) » et le lien d’inscription porte le code.',

  // ── Formulaire ─────────────────────────────────────────────────────────
  'envoiAcces.champ.prenom': 'Prénom',
  'envoiAcces.champ.nom': 'Nom',
  'envoiAcces.champ.email': 'Adresse électronique',
  'envoiAcces.champ.organisme': 'Organisme',
  'envoiAcces.champ.profil': 'Profil',
  'envoiAcces.profil.workshop_host': 'Animateur {lexWorkshopOf}',
  'envoiAcces.profil.exhibitor': '{lexExhibitorCap}',
  'envoiAcces.code.legende': 'Code d’accès',
  'envoiAcces.code.nouveau': 'Générer un nouveau code',
  'envoiAcces.code.existant': 'Utiliser un code en attente',
  'envoiAcces.code.menu': 'Code en attente',
  'envoiAcces.code.choisir': 'Choisir un code…',
  'envoiAcces.code.aucun': 'Aucun code en attente pour ce profil : générez un nouveau code.',
  'envoiAcces.code.option': '{code} · {libelle}',
  'envoiAcces.code.optionEnvoye': '{code} · {libelle} · déjà envoyé',
  'envoiAcces.code.sansLibelle': 'sans libellé',
  'envoiAcces.copies.case': 'Envoyer une copie à',
  'envoiAcces.copies.champ': 'Adresses en copie (une par ligne)',
  'envoiAcces.copies.aide':
    'Chaque adresse reçoit un courriel séparé, identique, précédé de la ligne « Copie de l’accès envoyé à Prénom Nom (adresse) ».',
  'envoiAcces.erreur.champs': 'Complétez le prénom, le nom, une adresse électronique valide et l’organisme.',
  'envoiAcces.erreur.code': 'Choisissez un code en attente, ou générez un nouveau code.',
  'envoiAcces.erreur.copies': 'Adresse(s) en copie invalide(s) : {liste}',
  'envoiAcces.erreur.serveur': 'L’opération n’a pas abouti : {message}',

  // ── Aperçu ─────────────────────────────────────────────────────────────
  'envoiAcces.btn.apercu': 'Voir l’aperçu',
  'envoiAcces.btn.modifier': 'Modifier',
  'envoiAcces.btn.envoyer': 'Envoyer le courriel',
  'envoiAcces.btn.annuler': 'Annuler',
  'envoiAcces.btn.fermer': 'Fermer',
  'envoiAcces.apercu.sujet': 'Sujet',
  'envoiAcces.apercu.destinataire': 'Destinataire',
  'envoiAcces.apercu.copies': 'Copies',
  'envoiAcces.apercu.aucuneCopie': 'Aucune copie',
  'envoiAcces.apercu.libelle': 'Libellé du code',
  'envoiAcces.apercu.ligneCopie': 'En tête de chaque copie : « {ligne} »',
  'envoiAcces.apercu.cadre': 'Aperçu du courriel',
  'envoiAcces.apercu.codeMasque':
    'Le code apparaît masqué dans l’aperçu ; le courriel envoyé porte le code complet, et le lien d’inscription le contient.',
  'envoiAcces.apercu.dejaEnvoye':
    'Ce code a déjà été envoyé le {date} à {email}. L’envoi vous sera demandé en confirmation.',
  'envoiAcces.confirm.renvoi':
    'Ce code a déjà été envoyé le {date} à {email} ({nombre, plural, one {# envoi} other {# envois}}). L’envoyer de nouveau ?',

  // ── Résultat ───────────────────────────────────────────────────────────
  'envoiAcces.succes': 'Accès envoyé à {nom} ({email}).',
  'envoiAcces.succes.copies': 'Copies envoyées : {liste}',
  'envoiAcces.succes.echecs': 'Copies non parties : {liste}',

  // ── Trace dans la liste ────────────────────────────────────────────────
  'envoiAcces.trace': 'Envoyé le {date} à {email} par {nom}',
  'envoiAcces.traceSansNom': 'Envoyé le {date} à {email}',
  'envoiAcces.traceNombre': '{nombre, plural, one {# envoi} other {# envois}}',

  // ── Adresses en copie (réglage) ────────────────────────────────────────
  'envoiAcces.copiesCarte.titre': 'Copies des envois d’accès',
  'envoiAcces.copiesCarte.aide':
    'Chaque courriel d’accès (code envoyé d’ici ou à l’approbation d’une demande, invitation au back-office, renvoi de lien) part aussi, séparément, vers ces adresses. Le lien d’activation d’une invitation n’y est jamais reproduit.',
  'envoiAcces.copiesCarte.champ': 'Adresses en copie de chaque courriel d’accès (une par ligne)',
  'envoiAcces.copiesCarte.btn': 'Enregistrer les copies',
  'envoiAcces.copiesCarte.succes': 'Adresses en copie enregistrées.',
  'envoiAcces.copiesCarte.vide': 'Aucune adresse : aucune copie n’est envoyée.',
};
